import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeOffPageConnector extends Shape {
    width = 200;
    height = 190;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width - 2 * horizontalPadding;
        const allowedHeight = (height * 5) / 8 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY =
            y + this.getTextLineHeight(textPart) + (height * 5) / 8 / 2 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        let r = height / 30;

        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + 2 * r, y); // 2*r потому что с просто r немного не правильно отображается угол
        canv.ctx.arcTo(x + width, y, x + width, y + (height * 5) / 8, r);
        canv.ctx.arcTo(x + width, y + (height * 5) / 8, x + width / 2, y + height, r);
        canv.ctx.arcTo(x + width / 2, y + height, x, y + (height * 5) / 8, r);
        canv.ctx.arcTo(x, y + (height * 5) / 8, x, y, r);
        canv.ctx.arcTo(x, y, x + width, y, r);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" d="M2 4.4c0-1.05.85-1.9 1.9-1.9h16.2c1.05 0 1.9.85 1.9 1.9v9.78a1.9 1.9 0 0 1-.85 1.59l-8.1 5.41a1.9 1.9 0 0 1-2.1 0l-8.1-5.41A1.9 1.9 0 0 1 2 14.18V4.4Z"/>
            </svg>
        `;
    }
}
